import React, { useState } from 'react';

const Form = (props) => {
  const personObj = {
    id: '',
    name: '',
    age: '',
    imgUrl: '',
  };
  const [isFull, setIsFull] = useState(false);
  const [person, setPerson] = useState(personObj);
  const { people, setPeople } = props;
  const [id, setId] = useState(people.length + 1);

  const handleChange = (evt) => {
    const inputName = evt.target.name;
    const inputValue = evt.target.value;
    setPerson({ ...person, id: id, [inputName]: inputValue });
  };
  const handleSubmit = (evt) => {
    if (people.length === 15) {
      setIsFull(true);
      return;
    }
    setId(id + 1);
    setPeople(people.concat(person));
    setPerson(personObj);

    evt.preventDefault();
  };
  return (
    <form className='form'>
      <fieldset>
        <h2>Add an entry</h2>
        <label htmlFor='name'>Name: </label>
        <input
          type='text'
          name='name'
          value={person.name}
          id='name'
          onChange={handleChange}
        />
        <label htmlFor='age'>Age: </label>
        <input
          type='text'
          name='age'
          id='age'
          value={person.age}
          onChange={handleChange}
        />
        <label htmlFor='img'>Img url: </label>
        <input
          type='text'
          id='img'
          name='imgUrl'
          value={person.imgUrl}
          onChange={handleChange}
        />
        <input
          type='button'
          className='btn'
          value='Submit'
          onClick={handleSubmit}
        />
        {isFull && <p>Remove someone to add more</p>}
      </fieldset>
    </form>
  );
};

export default Form;
